module.exports = __webpack_public_path__ + "img/cx30-20.5dfd80c5.png";